import { render } from "./TrendMetric.vue?vue&type=template&id=8093e82a"
import script from "./TrendMetric.vue?vue&type=script&lang=js"
export * from "./TrendMetric.vue?vue&type=script&lang=js"

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"TrendMetric.vue"]])

export default __exports__